import { render, staticRenderFns } from "./CollectionDelete.vue?vue&type=template&id=26588840&"
import script from "./CollectionDelete.vue?vue&type=script&lang=js&"
export * from "./CollectionDelete.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDelete.vue?vue&type=style&index=0&id=26588840&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports